import React from "react";
import PropTypes from "prop-types";

import styles from "./Button.module.css";

function Button({ variant = "primary", block, children, ...other }) {
  let display = styles.Button;
  let style = {};
  if (block) {
    display = styles.buttonBlock;
  }
  if (variant === "primary") {
    style = {
      backgroundImage: 'url("/images/button-design/Button-V4.png")',
    };
  } else if (variant === "secondary") {
    style = {
      backgroundImage: 'url("/images/button-design/Premium-Button-2.png")',
    };
  }
  return (
    <div className={display} style={style} {...other}>
      {children}
    </div>
  );
}

Button.propTypes = {
  variant: PropTypes.oneOf(["primary", "secondary"]),
  block: PropTypes.bool,
};

export default Button;
